<template>
  <div class="auth">
    <div class="mp-info card">
      <div class="title">
        <div class="title-text">
          <span class="decoration-line"></span>
          已授权的小程序
        </div>
        <div class="title-operate">
          <span
            class="button"
            @click="authAgain"
          >重新授权</span>
          <span
            class="button"
            @click="showUnBindingDialog"
          >解绑</span>
        </div>
      </div>
      <div class="content">
        <div class="left-side">
          <template v-if="!isLoading">
            <div
              v-if="mpInfo.head_img"
              class="avatar"
            >
              <img
                :src="mpInfo.head_img"
                alt="error"
                class="avatar-img"
              />
            </div>
            <div
              v-else
              class="no-avatar"
            >
              <ds-iconfont icon-class="icon-mk-xiaochengxu2" />
            </div>
          </template>
          <div class="left-info">
            <div class="info">
              <span class="key">小程序名称：</span>
              <span class="val">{{ mpInfo.nick_name }}</span>
            </div>
            <div class="info">
              <span class="key">认证状态：</span>
              <span
                v-if="mpInfo.verify_type_info && mpInfo.verify_type_info.id === 0"
                class="val"
              >已认证</span>
              <span
                v-else
                class="val"
              >未认证</span>
            </div>
          </div>
        </div>
        <div class="right-side">
          <div class="info">
            <span class="key">主体信息：</span>
            <span class="val">{{ mpInfo.principal_name }}</span>
          </div>
          <div class="hide-info"></div>
          <!-- <div class="info">
            <span class="key">认证状态：</span>
            <span class="val">
              审核中
              <mk-popover
                trigger="hover"
                placement="right"
                content="审核失败原因显示"
                popper-class="auth-management-mp-popover"
              >
                <ds-iconfont
                  slot="reference"
                  icon-class="icon-mk-tishi-info"
                />
              </mk-popover>
            </span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="version-info card">
      <div class="title">
        <div class="title-text">
          <span class="decoration-line"></span>
          版本信息
        </div>
      </div>
      <div class="content">
        <div class="left-side">
          <div class="info">
            <span class="key">当前版本</span>
          </div>
          <div class="info mr-15">
            <span class="key">版本号：</span>
            <span class="val">{{ versionInfo.nowVersion }}</span>
          </div>
          <div class="info">
            <span class="key">审核时间：</span>
            <span class="val">{{ versionInfo.nowVersionTime }}</span>
          </div>
        </div>
        <div
          v-if="versionInfo.newVersionStatus !== 0"
          class="right-side"
        >
          <div class="info">
            <span class="key">待上线版本</span>
          </div>
          <div class="info mr-15">
            <span class="key">版本号：</span>
            <span class="val">{{ versionInfo.newVersion }}</span>
          </div>
          <div class="info">
            <span class="key">审核状态：</span>
            <span class="val">
              <span
                class="decotarion-circle"
                :class="{'status-ok': versionInfo.newVersionStatus === 0,'status-fail': versionInfo.newVersionStatus === 1,'status-ing': versionInfo.newVersionStatus === 2,'status-cancel': versionInfo.newVersionStatus === 3}"
              ></span>
              <template v-if="versionInfo.newVersionStatus === 0">审核成功</template>
              <template v-else-if="versionInfo.newVersionStatus === 1">
                审核被拒绝
                <span
                  class="re-auth"
                  @click="reAuthDialog = true"
                >重新审核</span>
              </template>
              <template v-else-if="versionInfo.newVersionStatus === 2">审核中</template>
              <template v-else>已撤回</template>
            </span>
          </div>
          <div
            v-if="versionInfo.newVersionStatus === 1"
            class="info"
          >
            <span class="key">失败原因：</span>
            <span class="val">{{ versionInfo.rejectReason }}</span>
          </div>
          <div class="info">
            <span class="key">版本描述：</span>
            <span class="val">{{ versionInfo.newVersionDesc }}</span>
          </div>
        </div>
      </div>
    </div>

    <unbind-dialog :visible.sync="unBindingDialog" />

    <!-- 重新提交弹窗 -->
    <mk-dialog
      width="456px"
      :visible.sync="reAuthDialog"
    >
      <div class="dialog-title">
        <span>
          <ds-iconfont icon-class="icon-mk-tishi-info" />
          重新提交小程序
        </span>
        <span class="close">
          <i
            class="el-icon-close"
            @click="reAuthDialog = false"
          ></i>
        </span>
      </div>
      <div class="dialog-text">
        是否确认已按照反馈原因进行修改
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <mk-button
          size="medium"
          class="cancel-button"
          @click="reAuthDialog = false"
        >未修改</mk-button>
        <mk-button
          size="medium"
          type="primary"
          @click="reAuth"
        >已修改</mk-button>
      </span>
    </mk-dialog>
  </div>
</template>

<script>
import UnbindDialog from './components/unbind-dialog'
export default {
  name: 'Auth',
  components: {
    UnbindDialog
  },
  data () {
    return {
      unBindingDialog: false,
      mpInfo: {},
      versionInfo: {},
      // 是否正在加载
      isLoading: false,
      // 重新提交弹窗
      reAuthDialog: false
    }
  },
  created () {
    this.queryMpInfo()
    this.queryMpVersionInfo()
  },
  methods: {
    showUnBindingDialog () {
      this.unBindingDialog = true
    },
    // 再次授权
    authAgain () {
      const { VUE_APP_WX_OPEN_BASE_URL } = process.env
      const dustessUrl = encodeURIComponent(
        window.location.origin + '/#/settings/auth-management?type=2'
      )
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/mini/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.$emit('validateDialog', true)
    },
    async queryMpInfo () {
      this.isLoading = true
      const user = JSON.parse(window.localStorage.getItem('user'))
      let params = {
        companyId: user.account
      }
      let { success, data } = await WXOPENAPIS.ThirdPlatformMiniAuthApi.miniAuthInformationGet(params)
      if (success) {
        this.mpInfo = data.authorizer_info
      } else {
        this.$message.error('查询小程序信息出错')
      }
      this.isLoading = false
    },
    // 查询小程序版本信息
    async queryMpVersionInfo () {
      const user = JSON.parse(window.localStorage.getItem('user'))
      let params = {
        companyId: user.account
      }
      let { success, data } = await WXOPENAPIS.ThirdPlatformMiniAuthApi.miniAuthInformationVersionGet(params)
      if (success) {
        this.versionInfo = data
      }
    },
    // 重新授权
    async reAuth () {
      const user = JSON.parse(window.localStorage.getItem('user'))
      let params = {
        companyId: user.account
      }
      let { success, data } = await WXOPENAPIS.ThirdPlatformMiniAuthApi.miniAuthResubmitPost(params)
      if (success) {
        this.$message.success('提交成功')
        this.queryMpVersionInfo()
      } else {
        this.$message.error('提交失败')
      }
      this.reAuthDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  padding: 20px 20px 50px;

  .card {
    border: 1px solid #e8e8e8;

    .title {
      height: 42px;
      padding: 0 25px 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;

      .title-text {
        font-size: 13px;
        color: #1a0808;

        .decoration-line {
          display: inline-block;
          position: relative;
          top: 1px;
          width: 3px;
          height: 13px;
          background: rgba(0, 156, 255, 1);
          border-radius: 1px;
          margin-right: 5px;
        }
      }

      .title-operate {
        font-size: 13px;
        color: #009cff;
        cursor: pointer;
        user-select: none;

        .button {
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .content {
      padding: 20px 24px;
      display: flex;
      align-items: center;

      .left-side,
      .right-side {
        flex: 1;
      }

      .hide-info {
        margin-top: 24px;
      }

      .info {
        display: flex;
        font-size: 13px;
        line-height: 18px;

        &:not(:first-child) {
          margin-top: 10px;
        }

        .key {
          color: #595959;
          flex-shrink: 0;
        }

        .val {
          color: #262626;
          max-width: 340px;
        }

        .icon-mk-tishi-info {
          margin-left: 5px;
          cursor: pointer;
          font-size: 12px;
          color: #1890ff;
        }

        .to-be-submitted {
          color: #f7b500;
        }

        .in-audit {
          color: #009cff;
        }

        .success {
          color: #6dd400;
        }

        .fail {
          color: #a1a1a1;
        }

        .decotarion-circle {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          position: relative;
          top: -2px;
          margin-right: 8px;
        }

        .status-ok {
          background-color: #52c41a;
        }

        .status-fail {
          background-color: #ff6b6b;
        }

        .status-ing {
          background-color: #009cff;
        }

        .status-cancel {
          background-color: #bfbfbf;
        }
      }

      .mr-15 {
        margin-top: 15px !important;
      }

      .left-side {
        display: flex;
        align-items: center;

        .avatar,
        .no-avatar {
          width: 60px;
          height: 60px;
          border-radius: 4px;
          margin-right: 30px;
          overflow: hidden;
        }

        .avatar-img {
          width: 60px;
          height: 60px;
        }

        .no-avatar {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #d9d9d9;

          .icon-mk-xiaochengxu2 {
            color: #fff;
            font-size: 22px;
          }
        }
      }
    }
  }

  .version-info {
    margin-top: 22px;

    .content {
      padding-top: 27px;
      align-items: flex-start;
      padding-bottom: 130px;

      .left-side {
        display: block;
      }
    }
  }

  .re-auth {
    color: #009cff;
    margin-left: 16px;
    cursor: pointer;
  }

  /deep/ .el-dialog__header {
    display: none;
  }

  .dialog-title {
    height: 24px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #262626;

    .icon-mk-tishi-info {
      font-size: 19px;
      color: #fa8c15;
      margin-right: 11px;
    }

    .icon-mk-success {
      color: #15ad31;
      margin-right: 11px;
    }

    .el-icon-close {
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .dialog-text {
    padding-left: 35px;
    margin-top: 12px;
    color: #595959;
    line-height: 20px;
  }

  .cancel-button {
    color: #009cff;
    border-color: #ccecff;
  }

  /deep/ .el-dialog__body {
    padding: 17px 22px 28px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 0 !important;
  }
}
</style>

<style lang="scss">
.auth-management-mp-popover {
  padding: 6px 10px;
  min-width: auto;
  max-width: 200px;
  line-height: 20px;
}
</style>
